import { IKnoLevelErvk } from 'APIPackage/CatalogsModule/interfaces/IKnoLevelErvk';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryKnoLevelSelectOption = makeCreateDictionarySelectOption<IKnoLevelErvk>('id', 'name');
